export const routerConfig = {
    id: "efm-app",
    tagName: "MAIN-ELEMENT",
    path: "/",
    subRoutes: [{
        id: "login",
        tagName: "LOGIN-PAGE",
        path: "/login",
    }, {
        id: "users",
        tagName: "USERS-MAIN-VIEW",
        path: "/users",
        subRoutes: [{
            id: "add-user",
            tagName: "ADD-USER",
            path: "/users/add-user/:profileType",
            params: ["profileType"],
        }, {
            id: "edit-user-tab",
            tagName: "EDIT-USER-TAB",
            path: "/users/edit-user/:userId",
            params: ["userId"],
        }, {
            id: "change-password-view",
            tagName: "CHANGE-PASSWORD-VIEW",
            path: "/users/change-password",
        },
        ],
    }, {
        id: "audit",
        tagName: "AUDIT-DASHBOARD",
        path: "/audit-reporting",
        subRoutes: [{
            id: "audit-details",
            tagName: "AUDIT-DETAILS-PAGE",
            path: "/audit-reporting/audit-details-page/:traceId",
            params: ["traceId"],
        },
        ],
    }, {
        id: "reset-password",
        tagName: "RESET-PASSWORD",
        path: "/reset-password",
    }, {
        id: "set-password",
        tagName: "SET-PASSWORD",
        path: "/set-password",
    }, {
        id: "set-ssh",
        tagName: "SET-PASSWORD",
        path: "/set-sshkey",
    }, {
        id: "workflow",
        tagName: "WORKFLOW-MAIN-VIEW",
        path: "/workflows",
        subRoutes: [{
            id: "create-workflow-tab-view",
            tagName: "CREATE-WORKFLOW-TAB-VIEW",
            path: "/workflows/create-workflow",
        }, {
            id: "edit-workflow-tab-view",
            tagName: "EDIT-WORKFLOW-TAB-VIEW",
            path: "/workflows/edit-workflow/:workflowId",
            params: ["workflowId"],
        }, {
            id: "clone-workflow-tab-view",
            tagName: "CLONE-WORKFLOW-TAB-VIEW",
            path: "/workflows/clone-workflow/:workflowId",
            params: ["workflowId"],
        },
        ],
    },
    {
        id: "workflow-templates",
        tagName: "WORKFLOW-TEMPLATE-MAIN-VIEW",
        path: "/workflow-templates",
        subRoutes: [
            {
                id: "add-workflow-template",
                tagName: "WORKFLOW-TEMPLATE-GENERAL-VIEW",
                path: "/workflow-templates/add-workflow-template",
            },
            {
                id: "edit-workflow-template",
                tagName: "WORKFLOW-TEMPLATE-GENERAL-VIEW",
                path: "/workflow-templates/edit-workflow-template/:workflowTemplateId",
                params: ["workflowTemplateId"],
            },
            {
                id: "view-workflow-template",
                tagName: "WORKFLOW-TEMPLATE-GENERAL-VIEW",
                path: "/workflow-templates/view-workflow-template/:workflowTemplateId",
                params: ["workflowTemplateId"],
            },
        ],
    },
    {
        id: "business-units",
        tagName: "BUSINESS-UNITS-MAIN-VIEW",
        path: "/business-units",
        subRoutes: [{
            id: "add-business-unit",
            tagName: "ADD-BUSINESS-UNIT",
            path: "/business-units/add-business-unit",
        }, {
            id: "edit-business-unit",
            tagName: "EDIT-BUSINESS-UNIT",
            path: "/business-units/edit-business-unit/:businessUnitId",
            params: ["businessUnitId"],
        }, {
            id: "institutions",
            tagName: "INSTITUTIONS-MAIN-VIEW",
            path: "/business-units/:businessUnitId/institutions",
            params: ["businessUnitId"],
            subRoutes: [{
                id: "add-institution",
                tagName: "ADD-INSTITUTION",
                path: "/business-units/:businessUnitId/institutions/add-institution",
                params: ["businessUnitId"],
            }, {
                id: "edit-institution",
                tagName: "EDIT-INSTITUTION",
                path: "/business-units/:businessUnitId/institutions/edit-institution/:institutionUuid",
                params: ["businessUnitId", "institutionUuid"],
            }, {
                id: "institution-detail",
                tagName: "INSTITUTION-DETAIL-VIEW",
                path: "/business-units/:businessUnitId/institutions/detail/:institutionUuid",
                params: ["businessUnitId", "institutionUuid"],
            }, {
                // ACME-1403: legacy detail URLs before /detail/ segment; remove when external links migrate
                id: "institution-detail-legacy",
                tagName: "INSTITUTION-DETAIL-VIEW",
                path: "/business-units/:businessUnitId/institutions/:institutionUuid",
                params: ["businessUnitId", "institutionUuid"],
            }],
        },
        ],
    }, {
        id: "audit-export",
        tagName: "AUDIT-EXPORT",
        path: "/audit-export",
        subRoutes: [{
            id: "audit-export",
            tagName: "AUDIT-EXPORT",
            path: "/audit-export",
        },
        ],
    }, {
        id: "ip-whitelist",
        tagName: "IP-WHITELIST-MAIN-VIEW",
        path: "/ip-whitelist",
        subRoutes: [{
            id: "add-ip-whitelist",
            tagName: "ADD-IP-WHITELIST",
            path: "/ip-whitelist/add-ip-whitelist",
        },
        ],
    },
    {
        id: "health",
        tagName: "HEALTH",
        path: "/health",
    },
    // Vite `npm run dev` only — production builds omit this route.
    ...(import.meta.env.DEV
        ? [{
            id: "jhft-lab",
            tagName: "JHFT-LAB",
            path: "/lab",
        }]
        : []),
    {
        id: "callback-token",
        tagName: "CALLBACK-TOKEN",
        path: "/callback",
    }

    ],
};
